import { getDefaultHeight, SVG } from "./utils";

type Props = {
  color?: string;
} & React.SVGProps<SVGSVGElement>;

export const FailureIcon: React.FC<Props> = ({ color, ...svgProps }) => {
  return (
    <SVG
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      height={getDefaultHeight(svgProps, 24)}
      {...svgProps}
      fill={svgProps.fill ?? "none"}
      stroke={color ?? svgProps.stroke ?? "currentColor"}
      strokeWidth="1.5"
    >
      <circle cx="12" cy="12" r="12" stroke="none" />
      <circle cx="12" cy="12" r="11.25" />

      <path d="M12 5.5v9" strokeLinecap="round" />
      <g fill={color ?? svgProps.fill ?? "currentColor"}>
        <circle cx="12" cy="18" r="1" stroke="none" />
        <circle cx="12" cy="18" r=".5" />
      </g>
    </SVG>
  );
};
